






































































































































import {reactive, computed, defineComponent, ComputedRef} from '@vue/composition-api'
import SceneTemplateDialog from '@/components/NGL/SceneTemplateDialog.vue'
import {SceneShot} from '@/store/shots'
import {userStore, projectStore} from '@/store'
import CameraTrackDialog from '@/components/NGL/CameraTrackDialog.vue'
import SaveGltfDialog from '@/components/NGL/SaveGltfDialog.vue'
import Params from '@/components/Params.vue'
import RenderDialog, {renderDialogProps} from '@/components/NGL/RenderDialog.vue'
import type {Breakpoint} from 'vuetify/types/services/breakpoint'
import {trackEvent} from '@/analytics'

const components = {
  SceneTemplateDialog,
  CameraTrackDialog,
  SaveGltfDialog,
  RenderDialog,
  Params,
}

const props = {
  shot: {
    type: SceneShot,
    default: null,
  },
  spinning: {
    type: Boolean,
    default: null,
  },
  showDebugOverlay: {
    type: Boolean,
    default: null,
  },
}
export default defineComponent({
  name: 'NglLeftSidebar',
  components,
  props: {...props, ...renderDialogProps},
  setup(props, context) {
    const state = reactive({
      drawerOpen: true,
      paymentDialogOpen: false,
    })

    const toggleDrawer = () => {
      state.drawerOpen = !state.drawerOpen
    }
    // frame number, 1-based
    const currentFrame = computed(() => (projectStore ? projectStore.localFrame : 1))
    const isProduction = process.env.NODE_ENV === 'production'

    const allowRender = computed(() => {
      if (!userStore.user)
        return false
      if (userStore.user.isAnonymous)
        return false
      return !userStore.hasUnverifiedEmail;
    })

    const verifyEmailMessage = computed(() => {
      if (!userStore.user || userStore.user.isAnonymous)
        return "To Render, use non-guest account"
      else
        return "To Render, Verify Email"
    })
    const vbp: ComputedRef<Breakpoint> = computed(() => context.root.$vuetify.breakpoint)

    const showAxes = computed({
      get: () => userStore.profile?.ui.shotDesigner.axesVisible || false,
      set: val => userStore.setAxesVisible(val)
    })

    return {state, currentFrame, toggleDrawer, showAxes, isProduction, vbp, allowRender,
            verifyEmailMessage, trackEvent}
  }
})
